import { useState } from "react";
import { toast } from "sonner";
import { AppWindow, Globe2, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { translateError } from "@/i18n/errors";
import { useSpace } from "@/context/SpaceContext";

// One tap: move an official app between « Applications » and « Mini-sites web ».
export const CategoryToggle = ({ app, onChanged }) => {
  const { t } = useI18n();
  const { base } = useSpace();
  const [busy, setBusy] = useState(false);
  const mini = app.category === "minisite";
  const move = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`${base}/apps/${app.id}/category`, { category: mini ? "app" : "minisite" });
      toast.success(t(data.category === "minisite" ? "mini.movedMini" : "mini.movedApp", { name: data.name }));
      onChanged?.(data);
    } catch (err) {
      toast.error(translateError(err, t));
    } finally {
      setBusy(false);
    }
  };
  const Icon = busy ? Loader2 : mini ? AppWindow : Globe2;
  return (
    <button type="button" className="btn-gold btn-sm max-w-full whitespace-normal text-start" disabled={busy} onClick={move} data-testid={`category-toggle-${app.id}`}>
      <Icon className={`h-4 w-4 shrink-0 ${busy ? "animate-spin" : ""}`} /> {t(mini ? "mini.toApp" : "mini.toMini")}
    </button>
  );
};

export const CategoryBadge = ({ app }) => (
  <CategoryLabel mini={app.category === "minisite"} testId={`admin-app-category-${app.id}`} />
);

const CategoryLabel = ({ mini, testId }) => {
  const { t } = useI18n();
  return (
    <span className={`rounded-full border px-2 py-0.5 text-[0.65rem] font-semibold uppercase tracking-wider ${mini ? "border-emerald-400/60 text-emerald-200" : "border-[rgba(245,197,66,0.4)] text-[var(--gold-bright)]"}`} data-testid={testId}>
      {t(mini ? "mini.cat.minisite" : "mini.cat.app")}
    </span>
  );
};
